<ion-card [attr.data-cy]="dataCyTag + '-tile'" (click)="onClick()">
  <div class="tile-info">
    <div
      class="tile-heading"
      [class.mobile-font]="platformType === platformRef?.mobile"
    >
      {{ headingText | translate }}
    </div>
    <div
      class="tile-subheading"
      [class.mobile-font]="platformType === platformRef?.mobile"
      [class.tablet-font]="platformType === platformRef?.tablet"
    >
      {{ subHeadingText | translate }}
    </div>
  </div>
  <ion-icon
    name="chevron-forward-outline"
    [class.mobile-chevron]="platformType === platformRef?.mobile"
  ></ion-icon>
</ion-card>
